import LogoGlint from "@/components/LogoGlint";

/**
 * NoJo Enterprise brand mark.
 *
 * Sources the OFFICIAL approved N symbol from /nojo-logo.png. Uses
 * object-fit: contain so the full N is always visible — never cropped,
 * never distorted.
 *
 * Includes a subtle premium LogoGlint overlay that runs a double-pass
 * white streak on page load, then once every 120 seconds. The glint
 * honours prefers-reduced-motion automatically.
 */
export default function BrandMark({ size = 40, className = "", glint = true, glintSize }) {
  // Pick a glint size variant based on the rendered logo size.
  const variant = glintSize || (size >= 80 ? "huge" : size >= 50 ? "hero" : size >= 40 ? "footer" : "header");
  return (
    <span
      className={["relative inline-block shrink-0", className].join(" ")}
      style={{ width: `${size}px`, height: `${size}px`, lineHeight: 0 }}
    >
      <img loading="lazy" decoding="async"
        src="/nojo-logo.png"
        width={size}
        height={size}
        alt="NoJo Enterprise"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          objectFit: "contain",
          display: "block",
        }}
        draggable={false}
      />
      {glint && <LogoGlint size={variant} />}
    </span>
  );
}
